import { render, staticRenderFns } from "./RequestFundsCreation.vue?vue&type=template&id=28d67a8e&scoped=true"
import script from "./RequestFundsCreation.vue?vue&type=script&lang=js"
export * from "./RequestFundsCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d67a8e",
  null
  
)

export default component.exports